import axios from "axios";
const a = axios.create({
    baseURL: `https://gnatowski.ddns.net`,
    withCredentials: true
});
const s = axios.create({
    baseURL: `http://192.168.178.55:8087`,
    withCredentials: true
});
const w = axios.create({
    baseURL: `http://192.168.178.21/addons/xmlapi/`
});
export default {
    // user: {
    //     login: (username, password) => a.post('/api/login', { username, password })
    // },
    obd: {
        log: (data) => a.post('/api/worktime/obd/log', data)
    },
    tools: {
        kfz: () => a.get(`/api/kfz`),
        smoked: () => a.get(`/api/smoked/today`),
        smokedOn: d => a.get(`/api/smoked/${d}`),
        smoke: person => a.post(`/api/smoke`, { person }),
        // lotto: () => a.get(`/api/lotto`) 
    },
    stairs: {
        effects: () => s.get('/api/effects'),
        clear: () => s.post('/api/clear'),
        lower: (id) => s.get(`/api/distance/lower`),
        upper: (id) => s.get(`/api/distance/upper`),
        effect: (effect) => s.post(`/api/effect/${effect}`),
        color: (c) => { const t = `/api/color/${c.replace('#', '')}`; s.post(t); console.log('api.color', c, t); },
        play: (dir) => s.post(`/api/play/${dir}`),
        copy: (data) => s.post(`/api/copy`, data),
    },
    rubik: {
        move: (facelets, moves) => a.post(`/api/rubik/move`, { facelets, moves }),
        shuffle: (facelets) => a.post(`/api/rubik/shuffle`, { facelets }),
        verify: (facelets) => a.get(`/api/rubik/verify/${facelets}`),
        solve: facelets => a.get(`/api/rubik/solution/${facelets}`)
    },
    media: {
        tags: () => a.get(`/api/media/tags?uuid=${localStorage.getItem('device')}`),
        tagsHierarchy: () => a.get(`/api/media/tags/hierarchy?uuid=${localStorage.getItem('device')}`),
        setGps: (mediaId, latitude, longitude) => a.post(`/api/media/geo/${mediaId}`, { mediaId, latitude, longitude }),
        count: (filter) => a.post(`/api/media/count`, filter),
        matching: (filter) => a.post(`/api/media/matching`, filter),
        files: (filter) => a.post(`/api/media/files`, filter),
        item: (id) => a.get(`/api/media/item/${id}`),
        content: (id) => a.get(`/api/media/content/${id}`, { responseType: 'arraybuffer' }),
        batchUpdate: (data) => a.put(`/api/media/batch-update`, data)
    },
    faceGroups: {
        list: () => a.get(`/api/media/faces/groups`),
        addGroup: (name) => a.post(`/api/media/faces/group`, { name }),
        assignToGroup: (mediaId, faceIndex, groupName) => a.post(`/api/media/faces/assignTo`, ({ mediaId, faceIndex, groupName })),
        faces: (groupId) => a.get(`/api/media/faces/group/${groupId}`),
        rename: (groupId, name) => a.put(`/api/media/faces/rename(${groupId})`, { name }),
        moveFaces: (faces, groupId) => a.put(`/api/media/faces/assign/`, { faces, groupId }),
        deleteFace: (faceId) => a.delete(`/api/media/faces/${faceId}`),
        addFace: (faceData) => a.post(`/api/media/faces`, faceData),
        mergeGroups: (groupId, groups) => a.put(`/api/media/faces/group/merge`, ({ groupId, groups })),
        special: () => a.get(`/api/media/faces/groups/special`)
    },
    bike: {
        add: data => a.post(`/api/bike`, data),
        list: config => a.get(`/api/bike?${Object.keys(config).map(k => k + '=' + config[k]).join('&')}`)
    },
    lotto: {
        tickets: () => a.get('/api/lotto/tickets'),
        load: () => a.get('/api/lotto/load'),
        drawing: ut => a.get(`/api/lotto/drawing/${ut}`),
        simulation: cfg => a.post(`/api/lotto/simulation`, cfg),
        predicts: () => a.get(`/api/lotto/predicts`),
        forecast: (date, tickets, draws, strategy) => a.get(`/api/lotto/forecast/${date}/${tickets}/${draws}/${strategy}`),
        tests: () => a.get(`/api/lotto/tests`),
        test: (name) => a.get(`/api/lotto/test/${name}`),
    },
    eurojackpot: {
        list: () => a.get(`/api/eurojackpot`),
        drawing: ut => a.get(`/api/eurojackpot/${ut}`),
        random: () => a.get(`/api/eurojackpot/random`),
        simulation: cfg => a.get(`/api/eurojackpot/simulation/${cfg.year}/${cfg.count}`)
    },
    worktime: {
        firms: () => a.get('/api/worktime/firms'),
        projects: () => a.get('/api/worktime/projects'),
        timeMonths: () => a.get('/api/worktime/times/months'),
        times: params => a.get('/api/worktime/times', { params }),
        tasks: params => a.get('/api/worktime/tasks', { params }),
        taskFilters: () => a.get('/api/worktime/tasks/filters'),
        // activeTasks: () => a.get('/api/worktime/activeTasks'),
        getTimer: timerId => a.get(`/api/worktime/timer/${timerId}`),
        stopTimer: timerId => a.put(`/api/worktime/stop/${timerId}`),
        startTimer: (taskId, body) => a.post(`/api/worktime/start/${taskId}`, body),
        saveTask: task => a.post('/api/worktime/task', task),
        createBill: bill => a.post('/api/worktime/bill', bill),
        billYears: () => a.get('/api/worktime/billYears'),
        getBills: range => a.get('/api/worktime/bills', { params: range }),
        billAsPdf: id => a.get(`/api/worktime/billaspdf/${id}`, { responseType: "blob" }),
        saveBill: id => a.post(`/api/worktime/billaspdf/${id}`),
        drives: {
            list: () => a.get('/api/worktime/drives/list'),
            start: (userId, coords) => a.post('/api/worktime/drives/start', { userId, coords }),
            stop: (driveId, coords) => a.post('/api/worktime/drives/stop', { driveId, coords }),
            update: (driveId, data) => a.post(`/api/worktime/drives/${driveId}/update`, data)
        }
    },
    homematic: {
        rooms: () => a.get(`/api/homematic/rooms`),
        devices: () => a.get(`/api/homematic/devices`),
        states: () => a.get(`/api/homematic/states`),
    },
    auth: {
        register: (params) => a.post(`/api/auth/register`, params),
    },
    navi: {
        menu: params => a.get(`/api/navi/menu`, { params: { ...params, device: localStorage.getItem('device') } })
    },
    diary: {
        start: (gid, aid, hid) => a.post(`/api/diary/start/${gid}/${aid}/${hid}`),
        stop: (id) => a.post(`/api/diary/stop/${id}`),
        dates: () => a.get('/api/diary/dates'),
        last24h: () => a.get(`/api/diary/last24h/`),
        list: (date) => a.get(`/api/diary/list/${date}`)
    }
};
